<div class="container-edit-seat-plan">

  <div fxLayout="row" fxLayoutAlign="space-between center">
    <h5 class="edit-modal-title">{{ passedData.title }}</h5>
    <m-btn display="text" styles="rounded" color="black" [fontSize]="20" icon="fa-solid fa-xmark" (click)="dialogRef.close(false)" />
  </div>

  <div class="filters-menu-card">
    @if (eventPlacementEventId == null) {
      <div class="filter-edit-container" fxFlex fxLayout="row">
        <div class="full-width full-width_main">
          <ng-select class="full-width_first-child" [items]="placementTypes" placeholder="{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.PLACEHOLDER.PLACEMENT.TYPE'  | translate}}" bindLabel="Name" bindValue="Id" (change)="selectedPlacementTypeId = $event.Id" [clearable]="false"
          notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}"></ng-select>
        </div>
        <i class="fa fa-save" (click)="setProperty('PlacementTypeId', selectedPlacementTypeId)"></i>
        <i class="fa fa-hand-pointer" (click)="selectByProperty('PlacementTypeId', selectedPlacementTypeId)"></i>
      </div>
    }
    <div class="filter-edit-container" fxFlex fxLayout="row">

      <div [class.full-width_first-child]="eventPlacementEventId != null" class="full-width full-width_main">
        <ng-select [class.full-width_first-child]="eventPlacementEventId != null" class="full-width" [items]="priceCategories" placeholder="{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.PLACEHOLDER.PRICE.CATEGORY' | translate}}" bindLabel="Name" bindValue="Id"
        (change)="selectedPriceCategoryId = $event.Id" [clearable]="false" notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}"></ng-select>
      </div>

      <i class="fa fa-save" (click)="setProperty('PriceCategoryId', selectedPriceCategoryId)"></i>
      <i class="fa fa-hand-pointer" (click)="selectByProperty('PriceCategoryId', selectedPriceCategoryId);"></i>
    </div>
    <div class="filter-edit-container" fxFlex fxLayout="row">
      <div class="full-width full-width_main">
        <input class="form-control full-width" placeholder="{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.PLACEHOLDER.ROW-NAME' | translate}}" maxlength="64" #rowName>
      </div>
      <div fxflex="20px"><i class="fa fa-save" (click)="setProperty('RowNumber', rowName.value)"></i></div>
      <div fxFlex="20px" class="pad-right"><i class="fa fa-hand-pointer" (click)="selectByProperty('RowNumber', rowName.value);"></i></div>
    </div>
    <div class="filter-edit-container" fxFlex fxLayout="row">
      <div class="full-width full-width_main">
        <input class="form-control full-width" placeholder="{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.PLACEHOLDER.SEAT-NAME' | translate}}" maxlength="64" #seatName>
      </div>
      <i class="fa fa-save" (click)="setProperty('SeatNumber', seatName.value)"></i>
      <i class="fa fa-hand-pointer" (click)="selectByProperty('SeatNumber', seatName.value);"></i>
    </div>
    <div class="filter-edit-container" fxFlex fxLayout="row">
      <div class="full-width full-width_main">
        <ng-select class="full-width" [items]="seatRestrictionTypes" placeholder="{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.PLACEHOLDER.SEAT-RESTRICTION' | translate}}" bindLabel="Name" bindValue="Id" (change)="selectedSeatRestrictionTypeId = $event.Id" [clearable]="false"
        notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}"></ng-select>
      </div>

      <i class="fa fa-save" (click)="setProperty('SeatRestrictionId', selectedSeatRestrictionTypeId)"></i>
      <i class="fa fa-hand-pointer" (click)="selectByProperty('SeatRestrictionId', selectedSeatRestrictionTypeId)"></i>
    </div>
    <div class="filter-edit-container" fxFlex fxLayout="row">
      <div class="full-width full-width_main">
        <input class="form-control full-width" placeholder="{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.PLACEHOLDER.VIEW-FROM-SEAT-URL' | translate}}" maxlength="512" #panoramaUrl>
      </div>
      <div fxflex="20px"><i class="fa fa-save" (click)="setProperty('PanoramaUrl', panoramaUrl.value)"></i></div>
      <div fxFlex="20px" class="pad-right"><i class="fa fa-hand-pointer" (click)="selectByProperty('PanoramaUrl', panoramaUrl.value);"></i></div>
    </div>
    <div class="filter-edit-container" fxFlex fxLayout="row">

      <div class="full-width full-width_main">
        <ng-select class="full-width" #contingent [items]="contingents" placeholder="{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.PLACEHOLDER.CONTINGENT' | translate}}" bindLabel="Name" bindValue="Id" (change)="selectedContingentId = $event.Id" [clearable]="false"
        notFoundText="{{'GENERIC.EDITDIALOG.PLACEHOLDER.NOITEMSFOUND' | translate}}"></ng-select>
      </div>

      <i class="fa fa-save" (click)="setProperty('ContingentId', selectedContingentId)"></i>
      <i class="fa fa-hand-pointer" (click)="selectByProperty('ContingentId', selectedContingentId)"></i>

    </div>
    <div class="filter-edit-container" fxLayoutAlign="end center" fxLayout="row">
      <m-btn (click)="confirmAutoNumber()" icon="fas fa-magic" label="DIALOGS.EDIT-SEAT-PLAN.BUTTON.TITLE.ENABLE-NUMBERING" />

      <m-btn (click)="confirmRowOffset()" icon="fas fa-sort-numeric-down" label="DIALOGS.EDIT-SEAT-PLAN.BUTTON.ROW-OFFSET" title="DIALOGS.EDIT-SEAT-PLAN.BUTTON.TITLE.ENABLE-NUMBERING" [disabled]="selectedEndpoints.length != 1" />
    </div>

  </div>

  <div class="quality-panel" [class.visible]="isQualityMode">
    <h6>{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.QUALITY-MANAGEMENT' | translate}}</h6>

    <div class="quality-step">
      <div class="form-group">
        <label>{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.QUALITY' | translate}}</label>
        <input type="number" class="form-control" [(ngModel)]="qualityInput" min="1" [max]="bestSeatQuality">
      </div>
      <m-btn [disabled]="selectedEndpoints.length === 0" (click)="bulkUpdateQuality()" size="stretch" icon="fas fa-check" color="green" label="LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.BUTTON.APPLY-QUALITY-SCORES" />
    </div>

    <div class="quality-step">
      <div class="form-group">
        <label>{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.AUTOMATIC-QUALITY' | translate}}</label>
        <label class="help-text">{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.HELP.HORIZONTAL-QUALITY-STEP' | translate}}</label>
        <input type="number" class="form-control" [(ngModel)]="horizontalStep" min="1">
      </div>
      <div class="form-group">
        <label class="help-text">{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.HELP.VERTICAL-QUALITY-STEP' | translate}}</label>
        <input type="number" class="form-control" [(ngModel)]="verticalStep" min="1">
      </div>
      <m-btn [disabled]="selectedEndpoints.length === 0" (click)="calculateBestSeats()" size="stretch" icon="fas fa-calculator" color="blue" label="LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.BUTTON.RECALCULATE-BEST-SEATS" />
    </div>

    <div class="quality-actions">
      <m-btn (click)="resetQuality()" size="stretch" icon="fas fa-undo" color="red" label="LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.BUTTON.RESET-ALL-QUALITY" />
    </div>
  </div>

  <div class="legend-content" [class.visible]="isLegendVisible">
    @if (activePriceCategories.length > 0 ) {
      <div class="legend-seperator">{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.PLACEHOLDER.PRICE.CATEGORY' | translate}}</div>
    }
    @for (category of activePriceCategories; track category; let i = $index) {
      <div class="legend-row-title" fxLayout="row" fxLayoutWrap="wrap" (mouseenter)="hoveredPriceCategoryId = category.Id || null" (mouseleave)="hoveredPriceCategoryId = null;">
        <div fxFlex="40px" class="spr">
          <div class="sp-h" [style.background-color]="getPriceCategoryBackgroundColor(category.Id)"></div>
        </div>
        <div fxFlex>
          <p>{{ category.Name }}</p>
        </div>
      </div>
    }
    @if (activeSeatRestrictions.length > 0) {
      <div class="legend-seperator">{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.PLACEHOLDER.SEAT-RESTRICTION' | translate}}</div>
    }
    @for (restriction of activeSeatRestrictions; track restriction; let i = $index) {
      <div class="legend-row-title" fxLayout="row" fxLayoutWrap="wrap" (mouseenter)="hoveredRestrictionId = restriction.Id || null" (mouseleave)="hoveredRestrictionId = null">
        <div fxFlex="40px" class="spr">
          <div class="sp-h s-rv" [style.background-color]="'#7EB54E'"></div>
        </div>
        <div fxFlex>
          <p>{{ restriction.Name }}</p>
        </div>
      </div>
    }
    @if (activeContingents.length > 0) {
      <div class="legend-seperator">{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.PLACEHOLDER.CONTINGENT' | translate}}</div>
    }
    @for (contingent of activeContingents; track contingent; let i = $index) {
      <div class="legend-row-title" fxLayout="row" fxLayoutWrap="wrap" (mouseenter)="hoveredContingentId = contingent.Id || null" (mouseleave)="hoveredContingentId = null">
        <div fxFlex="40px" class="spr">
          <div class="sp-h" [style.background-color]="getContingentColor(contingent)"></div>
        </div>
        <div fxFlex>
          <p>{{ contingent.Name }}</p>
        </div>
      </div>
    }
    @if (activePriceCategories.length > 0 || activeContingents.length > 0 || activeSeatRestrictions.length > 0) {
      <div class="legend-seperator"></div>
    }
    <div class="legend-row-title" fxLayout="row" fxLayoutWrap="wrap">
      <div fxFlex="40px" class="spr">
        <div class="sp-h" [style]="seatPlanHelper.getArtifactStyle([{HexColor: '#c7ae5d', Id: 1}], 1, false, null, null, true)"></div>
      </div>
      <div fxFlex>
        <p>{{'SALES.ORDERS.NEW.SEATPLAN.LEGEND.FREE-POSITION' | translate}}</p>
      </div>
    </div>
    <div class="legend-row-title" fxLayout="row" fxLayoutWrap="wrap">
      <div fxFlex="40px" class="spr">
        <div class="sp-h" [style]="seatPlanHelper.getArtifactStyle([{HexColor: '#c7ae5d', Id: 1}], 1, true, null, null, true)"></div>
      </div>
      <div fxFlex>
        <p>{{'SALES.ORDERS.NEW.SEATPLAN.LEGEND.SOLD' | translate}}</p>
      </div>
    </div>
    <div class="legend-row-title" fxLayout="row" fxLayoutWrap="wrap">
      <div fxFlex="40px" class="spr">
        <div class="sp-h" [style]="seatPlanHelper.getArtifactStyle([{HexColor: '#c7ae5d', Id: 1}], 1, false, null, '#8a0481', true)"></div>
      </div>
      <div fxFlex>
        <p>{{'SALES.ORDERS.NEW.SEATPLAN.LEGEND.RESERVED' | translate}}</p>
      </div>
    </div>
    <div class="legend-row-title" fxLayout="row" fxLayoutWrap="wrap">
      <div fxFlex="40px" class="spr">
        <div class="sp-h" [style]="seatPlanHelper.getArtifactStyle([{HexColor: '#c7ae5d', Id: 1}], 1, false, 1, null, false)"></div>
      </div>
      <div fxFlex>
        <p>{{'SALES.ORDERS.NEW.SEATPLAN.LEGEND.NOT-AVAILABLE' | translate}}</p>
      </div>
    </div>
    <div class="legend-row-title" fxLayout="row" fxLayoutWrap="wrap">
      <div fxFlex="40px" class="spr">
        <div class="sp-h" [style]="seatPlanHelper.getArtifactStyle([{HexColor: '#c7ae5d', Id: 1}], 1, false, 1, null, true)"></div>
      </div>
      <div fxFlex>
        <p>{{'SALES.ORDERS.NEW.SEATPLAN.LEGEND.CONTINGENT-AVAILABLE' | translate}}</p>
      </div>
    </div>
    <div class="legend-row-title" fxLayout="row" fxLayoutWrap="wrap">
      <div fxFlex="40px" class="spr">
        <div class="sp-h" [style]="seatPlanHelper.getArtifactStyle([{HexColor: '#c7ae5d', Id: 1}], 1, true, 1, null, true)"></div>
      </div>
      <div fxFlex>
        <p>{{'SALES.ORDERS.NEW.SEATPLAN.LEGEND.CONTINGENT-SOLD' | translate}}</p>
      </div>
    </div>
    <div class="legend-row-title" fxLayout="row" fxLayoutWrap="wrap">
      <div fxFlex="40px" class="spr">
        <div class="sp-h s-rv" [style]="seatPlanHelper.getArtifactStyle([{HexColor: '#c7ae5d', Id: 1}], 1, false, null, null, true)"></div>
      </div>
      <div fxFlex>
        <p>{{'SALES.ORDERS.NEW.SEATPLAN.LEGEND.RESTRICTION' | translate}}</p>
      </div>
    </div>
    <div class="legend-seperator"></div>
    <div class="app-key-holder" fxLayout="row">
      {{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.INFO.SELECT' | translate}}
      <div class="app-key-lmouse">&nbsp;</div> +
      <div class="app-key">{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.INFO.DRAG' | translate}}</div>
    </div>
    <div class="app-key-holder " fxLayout="row">
      {{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.INFO.DESELECT' | translate}}
      <div class="app-key">Ctrl</div> +
      <div class="app-key-lmouse">&nbsp;</div> +
      <div class="app-key">{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.INFO.DRAG' | translate}}</div>
    </div>
    <div class="app-key-holder" fxLayout="row">
      {{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.INFO.MOVE' | translate}}
      <div class="app-key-rmouse">&nbsp;</div> +
      <div class="app-key">{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.INFO.DRAG' | translate}}</div>
    </div>
    <div class="app-key-holder" fxLayout="row">
      {{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.INFO.ZOOM-UNZOOM' | translate}}
      <div class="app-key">{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.INFO.SCROLL' | translate}}</div>
    </div>
  </div>

  <div id="focal" class="plan-holder-custom">

    <div class="app-key-area" fxLayout="row">
      <m-btn (click)="toggleLegend()" styles="rounded" [color]="isLegendVisible ? 'red': 'blue'" icon="fas fa-info-circle" [label]="isLegendVisible ? 'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.BUTTON.LEGAENDA.EXIT' : 'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.BUTTON.LEGAENDA'" />

      <div class="legend-button-wrapper">
        <m-btn (click)="toggleQualityMode()" styles="rounded" [color]="isQualityMode ? 'red': 'blue'" icon="fas fa-star" [title]="'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.TOGGLE-QUALITY-MODE' | translate" [label]="isQualityMode ? 'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.EXIT-QUALITY-MODE' : 'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.QUALITY-MODE' | translate" />

        <m-btn (click)="clearSelection()" styles="rounded" color="red" icon="fa-solid fa-circle-xmark" label="{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.BUTTON.EMPTY-SECTION' | translate}} ({{selectedEndpoints.length}})" [disabled]="selectedEndpoints.length == 0" />
      </div>
    </div>

    <div #planHolder class="panzoom-parent">

      <div id="seatPlan" #seatPlan class="seat-plan">
        @for (row of rows; track row; let rowIdx = $index) {
          <div class="spr">
            <div class="seat-row">{{ determineRowName(row) }}</div>
            @for (c of row.columns; track c; let colIdx = $index) {
              @if (c.data !== null) {
                <div #seatElement data-id="{{c.data.Id}}" [style]="isQualityMode ? getQualityStyleSafe(c.data) : c.artifectStyle" [class.sp-sel]="c.selected" [class.legend-highlight]="isSeatHighlighted(c.data)" [class]="c.Classes" class="seat-with-tooltip"
                  (mouseenter)="onSeatHover(c.data, $event)" (mouseleave)="currentHoveredSeat = null">
                  {{c.SeatName}}
                </div>
              }
            }
            <div class="seat-row"> {{ determineRowName(row) }}</div>
          </div>
        }

        <div class="seat-row-full-field">{{'LOCATION.VENUE-DEFINITION.EDIT-SEATPLAN-DIALOG.LABEL.VIELD' | translate}}</div>

      </div>

    </div>

  </div>

  <div class="edit-seat-plan-buttons">
    <m-btn (click)="dialogRef.close(false);" color="red" icon="fas fa-window-close" label="GENERIC.BUTTON.CANCEL" />
    <m-btn (click)="storeChanges()" [disabled]="!isDirty || saving" icon="far fa-save" label="GENERIC.BUTTON.SAVE" />
  </div>

  @if (currentHoveredSeat && !isDragging) {
    <m-tooltip [content]="getSeatTooltipContent()" [position]="tooltipPosition" [imageUrl]="currentHoveredSeat?.PanoramaUrl" />
  }

</div>